import { auth } from "@helloaudio/auth";
import { buildAttributionFromLocation } from "../../../../utils/attribution";

import GuardFunction from "../GuardFunction";

/**
 * Requires users to be authenticated.
 * But instead of redirecting users to login page, it redirects them to signup page.
 * Use in case you know user wants to signup. (e.g. User clicked on signup button), otherwise use `loginGuard`.
 *
 * @returns boolean
 */
const signupGuard: GuardFunction = async () => {
  const isAuthenticated = await auth.isAuthenticated();
  if (!isAuthenticated) {
    const attribution = buildAttributionFromLocation();
    await auth.signupWithRedirect(undefined, attribution);
    return false;
  }

  return true;
};

export default signupGuard;
